/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { Box, createTheme, CssBaseline, ThemeProvider } from '@mui/material'
import { Dispatch } from '@reduxjs/toolkit'
import jwtDecode from 'jwt-decode'
import { useSnackbar } from 'notistack'
import qs from 'qs'
import React, { FC, useEffect, useRef, useState } from 'react'
import { Provider, useDispatch, useSelector } from 'react-redux'
import { BrowserRouter, Routes, Route } from 'react-router-dom'

import { LOGIN } from './config/constants'
import * as routes from './config/constants'
import darkTheme from './config/darkTheme'
import theme from './config/theme'
import ChangePasswordScreen from './screens/auth/ChangePasswordScreen'
import ConfirmRegisterScreen from './screens/auth/ConfirmRegisterScreen'
import ForgetPasswordScreen from './screens/auth/ForgetPasswordScreen'
import LoginScreen from './screens/auth/LoginScreen'
import DeviceTokenComponent from './devicetoken'
// import LoginScreen from './screens/auth/LoginScreen'
import RegisterScreen from './screens/auth/RegisterScreen'
import DeviceListScreen from './screens/authDevice/DeviceListScreen'
import DeviceScreen from './screens/authDevice/DeviceScreen'
import RegisterDevice from './screens/authDevice/RegisterDeviceScreen'
import CarDetailsScreen from './screens/cars/CarDetailsScreen'
import CarsScreen from './screens/cars/CarsScreen'
import ChartEngineScreen from './screens/cars/ChartEngineScreen'
import ChartInfoEngineScreen from './screens/cars/ChartInfoEngineScreen'
import ErrorEngineScreen from './screens/cars/ErrorEngineScreen'
import HistoryErrorsScreen from './screens/cars/HistoryErrorsScreen'
import InfoEngineScreen from './screens/cars/InfoEngineScreen'
import LocationScreen from './screens/cars/LocationScreen'
import LocationTrip from './screens/cars/LocationTrip'
import NewCarScreen from './screens/cars/NewCarScreen'
import PathstraveledScreen from './screens/cars/PathsTraveledScreen'
import PeriodicServiceScreen from './screens/cars/PeriodicServiceScreen'
import ReportEngineScreen from './screens/cars/ReportEngineScreen'
import Search from './screens/cars/Search'
import SecurityScreen from './screens/cars/SecurityScreen'
import StatusDeviceScreen from './screens/cars/StatusDeviceScreen'
import TripsCarScreen from './screens/cars/TripsCarScreen'
import Container from './screens/layout/Container'
import ChangePasswordProfile from './screens/profile/ChangePasswordProfile'
import ProfileScreen from './screens/profile/ProfileScreen'
import SettingsScreen from './screens/settings/SettingsScreen'
import TicketsScreen from './screens/ticket/TicketsScreen'
import {
  getError,
  getIsLogged,
  receiveAppToken,
  setError,
  setLogged,
  setLoggedUser,
  setTokenUser,
} from './store/auth'
import { getTheme } from './store/ui'
import PrivateRoutes from './utils/PrivateRoutes'

// import ConfirmRegisterScreen from './screens/auth/ConfirmRegisterScreen'
// import ForgetPasswordScreen from './screens/auth/ForgetPasswordScreen'
// import LoginScreen from './screens/auth/LoginScreen'
// import RegisterScreen from './screens/auth/RegisterScreen'

const App: FC = () => {
  const IsLogged = useSelector(getIsLogged)
  const dispatch = useDispatch<Dispatch<any>>()
  const error = useSelector(getError)
  const { enqueueSnackbar } = useSnackbar()
  const themeApp = useSelector(getTheme)
  useEffect(() => {
    dispatch(receiveAppToken)
  }, [])

  return (
    <ThemeProvider theme={themeApp === 'dark' ? theme : darkTheme}>
      <CssBaseline />
      <BrowserRouter>
        <Box display='flex' flexDirection='column'>
          <Box height='90vh' sx={{ overflow: 'overlay' }}>
            <Routes>
              <Route element={<PrivateRoutes />}>
                <Route element={<SettingsScreen />} path={routes.SETTINGS} />
                <Route element={<ProfileScreen />} path={routes.PROFILE} />
                <Route element={<TicketsScreen />} path={routes.TICKETS} />
                <Route element={<CarsScreen />} path={routes.CARS} />
                <Route element={<RegisterDevice />} path={routes.REGISTER_DEVICE} />
                <Route element={<CarDetailsScreen />} path={`${routes.CARS}/:id`} />
                <Route element={<DeviceScreen />} path={routes.DEVICES} />
                <Route element={<DeviceListScreen />} path={routes.DEVICES_LIST} />/
                <Route element={<LocationTrip />} path={routes.LOCATION_TRIP} />/
                <Route element={<NewCarScreen />} path={`${routes.NEW_CAR}/:id`} />
                <Route element={<LocationScreen />} path={`${routes.LOCATION}/:id`} />
                <Route element={<InfoEngineScreen />} path={`${routes.INFO_ENGINE}/:id`} />
                <Route
                  element={<PeriodicServiceScreen />}
                  path={`${routes.PERIODIC_SERVICE}/:id`}
                />
                <Route element={<ReportEngineScreen />} path={`${routes.REPORT_ENGINE}/:id`} />
                <Route element={<ErrorEngineScreen />} path={`${routes.ERROR_ENGINE}/:id`} />
                <Route element={<HistoryErrorsScreen />} path={`${routes.HISTORY_ERRORS}/:id`} />
                <Route element={<ChartEngineScreen />} path={routes.CHART_ENGINE} />
                <Route element={<PathstraveledScreen />} path={`${routes.PATHS_TRAVELED}/:id`} />
                <Route element={<TripsCarScreen />} path={`${routes.TRIPS_CAR}/:id`} />
                <Route element={<StatusDeviceScreen />} path={`${routes.STATUS_DEVICE}/:id`} />
                <Route element={<ChartInfoEngineScreen />} path={routes.CHART_INFO_ENGINE} />
                <Route element={<SecurityScreen />} path={`${routes.SECURITY}/:id`} />
                <Route element={<Search />} path={routes.SEARCH} />
              </Route>

              <Route element={<LoginScreen />} path='/' />
              <Route element={<LoginScreen />} path={routes.LOGIN} />
              <Route
                element={<ChangePasswordProfile />}
                path={`${routes.PROFILE}/${routes.CHANGE_PASSWORD_PROFILE}`}
              />
              <Route element={<RegisterScreen />} path={routes.REGISTER} />
              <Route element={<ForgetPasswordScreen />} path={routes.FORGET_PASSWORD} />
              <Route element={<ChangePasswordScreen />} path={routes.CHANGE_PASSWORD} />
              <Route element={<ConfirmRegisterScreen />} path={routes.CONFIRM_REGISTER} />

              <Route element={<DeviceTokenComponent />} path="/tokenhandler" />
            </Routes>
          </Box>
          <Box
            alignItems='center'
            display='flex'
            height='10vh'
            justifyContent='center'
            overflow='hidden'
            sx={{ zIndex: '1000000000' }}
          >
            <Container />
          </Box>
        </Box>
      </BrowserRouter>
    </ThemeProvider>
  )
}

export default App
